import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { DialogApprovalsEquipmentsDiffComponent } from 'app/main/approvals-equipments/dialog/dialog-approvals-diff/dialog-approvals-equipments.component';
import { DialogApprovalsEquipmentsComponent } from 'app/main/approvals-equipments/dialog/dialog-approvals-new/dialog-approvals-equipments.component';
import { ApprovalsEquipmentsApi } from 'app/main/approvals-equipments/services/api/approvals-equipments-api.service';
import { EquipmentsService } from 'app/main/equipments/services/equipments-resolver.service';
import { findIndex, reject, sortBy } from 'lodash';
import moment from 'moment-timezone';
import { CreateEquipmentApprovalsLogsService } from './services/create-equipment-approvals-logs.service';
import { CreateEquipmentLogsService } from './services/create-equipment-logs.service';
import { UpdatedByLogService } from './services/updated-by-log.service';
var TabEquipmentHistoricComponent = /** @class */ (function () {
    function TabEquipmentHistoricComponent(dialogData, createEquipmentLogs, createApprovalsLogs, updatedByLog, fuseProgressBarService, matDialog, equipmentsService, approvalsEquipmentsApi) {
        this.dialogData = dialogData;
        this.createEquipmentLogs = createEquipmentLogs;
        this.createApprovalsLogs = createApprovalsLogs;
        this.updatedByLog = updatedByLog;
        this.fuseProgressBarService = fuseProgressBarService;
        this.matDialog = matDialog;
        this.equipmentsService = equipmentsService;
        this.approvalsEquipmentsApi = approvalsEquipmentsApi;
        this.todayDate = moment().format('DD/MM/YYYY');
        this.yesterdayDate = moment().subtract(1, 'days').format('DD/MM/YYYY');
        this.equipmentLogsMapped = [];
    }
    TabEquipmentHistoricComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var logsMerged, approvals, _a, equipmentLogsMapped, approvalLogsMapped, equipmentsLogsWithUpdatedBy, approvalsLogsWithUpdatedBy, indexOfFirstApproval;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        logsMerged = [];
                        if (!(this.dialogData.equipment == null)) return [3 /*break*/, 1];
                        _a = [];
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.approvalsEquipmentsApi.listApprovalsEquipments({
                            where: {
                                qrCode_contains: this.dialogData.equipment.qrCode,
                                status_in: ['pending', 'approved', 'refused']
                            },
                            orderBy: 'createdAt_asc',
                            offset: 0,
                            limit: 10000
                        }).toPromise().then(function (result) { return result.items; })];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        approvals = _a;
                        equipmentLogsMapped = this.createEquipmentLogs.listEquipmentLogsMapped(this.dialogData.equipment);
                        approvalLogsMapped = this.createApprovalsLogs.listApprovalsLogsMapped(this.dialogData.equipment.logs, approvals);
                        equipmentsLogsWithUpdatedBy = this.updatedByLog.customUpdatedByInLogs(equipmentLogsMapped);
                        approvalsLogsWithUpdatedBy = this.updatedByLog.customUpdatedByInLogs(approvalLogsMapped);
                        approvalsLogsWithUpdatedBy.forEach(function (approvalLog) {
                            equipmentsLogsWithUpdatedBy = reject(equipmentsLogsWithUpdatedBy, function (log) {
                                return approvalLog.approvedStatus === 'approved' &&
                                    moment(approvalLog.createdAt).isSame(moment(log.createdAt));
                            });
                        });
                        logsMerged.push.apply(logsMerged, tslib_1.__spread(approvalsLogsWithUpdatedBy, equipmentsLogsWithUpdatedBy));
                        this.equipmentLogsMapped = sortBy(logsMerged, 'createdAt');
                        indexOfFirstApproval = findIndex(this.equipmentLogsMapped, function (log) { return log.approval; });
                        if (indexOfFirstApproval >= 0) {
                            this.equipmentLogsMapped = reject(this.equipmentLogsMapped, function (log, index) {
                                return index > indexOfFirstApproval && log.isEquipmentCreatedLog;
                            });
                        }
                        this.equipmentLogsMapped = this.equipmentLogsMapped.reverse();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabEquipmentHistoricComponent.prototype.getDialog = function (result) {
        if (result.equipment && result.approval.status === 'pending') {
            return this.matDialog.open(DialogApprovalsEquipmentsDiffComponent, {
                panelClass: ['dialog-approval-equipment-diff'],
                data: {
                    approval: result.approval,
                    equipment: result.equipment
                }
            });
        }
        return this.matDialog.open(DialogApprovalsEquipmentsComponent, {
            panelClass: ['dialog-approval-equipment'],
            data: result.approval
        });
    };
    TabEquipmentHistoricComponent.prototype.openDialog = function (approval) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fuseProgressBarService.show();
                        return [4 /*yield*/, this.equipmentsService.getApprovalAndEquipment({
                                approvalId: approval.id,
                                equipmentQrCode: approval.equipment.qrCode
                            })];
                    case 1:
                        result = _a.sent();
                        this.fuseProgressBarService.hide();
                        return [2 /*return*/, this.getDialog(result).afterClosed().toPromise()];
                }
            });
        });
    };
    return TabEquipmentHistoricComponent;
}());
export { TabEquipmentHistoricComponent };
